import {useTranslationWithOverride} from 'components/src/hook/UseTranslationWithOverride';
import {WarningTriangle} from 'iconoir-react';
import Button from 'react-bootstrap/Button';
import {isRouteErrorResponse, useNavigate, useRouteError} from 'react-router-dom';

export function ErrorPage()
{
    const error = useRouteError();
    const navigate = useNavigate();
    const {t} = useTranslationWithOverride();

    let message: string | undefined;
    if (isRouteErrorResponse(error)) {
        message = error.statusText;
    } else if (error instanceof Error) {
        message = error.message;
    }

    return (
        <div className="d-flex flex-column min-vh-100 align-items-center justify-content-center bg-body-secondary">
            <div className="mb-4">
                <img src={t(['login.logo'])} alt="CipherMail" style={{width: 'var(--cm-login-logo-width)'}}/>
            </div>

            <div className="bg-body shadow-sm rounded p-4 text-center" style={{maxWidth: '480px', width: '100%'}}>
                <WarningTriangle
                    style={{width: '3rem', height: '3rem', color: 'var(--cm-app-color)'}}
                    className="mb-3"
                />
                <h4 className="mb-3">{t('error-page.title')}</h4>
                {message && <p className="text-secondary mb-4">{message}</p>}
                <Button variant="success" onClick={() => navigate('/')}>
                    {t('error-page.continue')}
                </Button>
            </div>
        </div>
    );
}
